import { useState, type FormEvent } from "react";
import { ApiClientError, loginWithPassword } from "../api/client";

/**
 * ログイン画面（ユーザー名＋パスワード）。
 * - 利用者一覧（ADCONSOLE_USERS_JSON）運用ではユーザー名が必須（BFF が 422 USER_REQUIRED を返す）
 * - パスワード1本運用（未設定）ではユーザー名は空のままでよい（BFF が無視する）
 * 成功したら画面を再読み込みして、直前まで失敗していたデータ取得を再試行する。
 */
export function LoginPage() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!password || busy) return;
    const attempted = password;
    const attemptedUser = user.trim();
    // 送信直後にstateをクリアする（成功/失敗どちらの結果を待つ前に）。
    // 失敗時にパスワードがReact state（延いてはメモリ・devtools）に残り続けないよう、
    // 再入力を必須にする（B2対応）。ユーザー名は残す（打ち直しの手間だけなので）。
    setPassword("");
    setBusy(true);
    setError(null);
    try {
      await loginWithPassword(attempted, attemptedUser || undefined);
      window.location.reload();
    } catch (err) {
      setError(err instanceof ApiClientError ? err.message : "ログインに失敗しました。");
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <div className="sidebar-brand" style={{ padding: 0, marginBottom: 4 }}>
          STOQ広告管理コンソール
        </div>
        <p style={{ color: "var(--ink-sub)", fontSize: 13, margin: "0 0 16px" }}>
          ログインが必要です。発行されたユーザー名とパスワードを入力してください。
        </p>
        <label className="login-label" htmlFor="login-user">
          ユーザー名
        </label>
        <input
          id="login-user"
          className="search-input"
          style={{ maxWidth: "none", width: "100%" }}
          type="text"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          placeholder="ユーザー名"
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoFocus
        />
        <label className="login-label" htmlFor="login-password" style={{ marginTop: 10 }}>
          パスワード
        </label>
        <input
          id="login-password"
          className="search-input"
          style={{ maxWidth: "none", width: "100%" }}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="パスワード"
          autoComplete="current-password"
        />
        {error && (
          <p style={{ color: "var(--danger)", fontSize: 12.5, marginTop: 8 }} role="alert">
            {error}
          </p>
        )}
        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: "100%", marginTop: 14 }}
          disabled={busy || !password}
        >
          {busy ? "ログイン中…" : "ログイン"}
        </button>
      </form>
    </div>
  );
}
